import { useEffect } from 'react';

interface Params {
	shouldShow: boolean;
}

export default function usePnlModalConfetti({ shouldShow }: Params) {
	useEffect(() => {
		if (!shouldShow) {
			return;
		}

		import('canvas-confetti').then(({ default: confetti }) => {
			confetti({
				colors: [
					'#e8a2a0',
					'#c187c5',
					'#b47ed2',
					'#aa77db',
					'#a070e5',
					'#9468f1',
					'#8d7cef',
					'#8690ee',
					'#7fa4ec',
					'#78b8eb',
					'#71cce9',
				],
				origin: { y: 0.7 },
				particleCount: 100,
				spread: 75,
				// Ensure it sits above the modal.
				zIndex: 1000,
			});
		});
	}, [shouldShow]);
}
